import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../core';

import { FormaPagamentoFilter } from '../filter';
import { FormaPagamentoCrudHttpService } from '../services';
import { formaPagamentoSituacaoAtiva, isFormaPagamentoSituacaoInativa } from '../forma-pagamento-situacao';
import { FormaPagamento } from '../forma-pagamento';

@Component({
    selector: 'sgt-forma-pagamento-select',
    templateUrl: './forma-pagamento-select.component.html',
    styleUrls: ['./forma-pagamento-select.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => FormaPagamentoSelectComponent), multi: true },
    ]
})
export class FormaPagamentoSelectComponent implements OnInit {
    /** ID da forma de pagamento */
    @Input() ngModel: number;
    /** Ao alterar a forma de pagamento */
    @Output() ngModelChange = new EventEmitter<number>();

    /** Forma de Pagamento */
    @Input() formaPagamento: FormaPagamento;
    @Output() formaPagamentoChange = new EventEmitter<FormaPagamento>();

    /** Formas de pagamentos */
    formasPagamentos: FormaPagamento[] = [];

    /** Nome do input */
    @Input() name: string;
    /* ID do input */
    @Input() id: string;
    /* Se o valor é obrigatório */
    @Input() required: any;
    /* Se deve desabilitar o input */
    @Input() disabled: boolean;
    /** Se deve setar o focus automaticamente */
    @Input() autofocus = false;
    /** Se deve pesquisar os formas de pagamentos ao iniciar o component */
    @Input() searchOnInit = true;
    /** Se pode selecionar nenhuma opção */
    @Input() canSelectNull = true;
    /** Label para a opção de selecionar a opção nula */
    @Input() nullLabel = 'NENHUMA FORMA DE PAGAMENTO'
    /** Se deve filtrar somente as formas de pagamentos ativas */
    @Input() somenteAtivas = false;

    @ViewChild('select') select: ElementRef;

    propagateChange: any = () => {};

    constructor(private messageService: MessageService,
                private formaPagamentoCrudHttpService: FormaPagamentoCrudHttpService) { }

    ngOnInit() {
        if (this.searchOnInit) {
            this.search();
        }
    }


    /** Pesquisa as formas de pagamentos */
    search(): Promise<FormaPagamento[]> {
        return new Promise<FormaPagamento[]>((resolve, reject) => {
            this.formasPagamentos = [];


            const filter = new FormaPagamentoFilter();
            // Somente ativas
            if (this.somenteAtivas) {
                filter.situacao = formaPagamentoSituacaoAtiva.id;
            }


            this.formaPagamentoCrudHttpService.searchWithFilter(filter)
                .pipe(
                    take(1)
                )
                .subscribe(
                    formasPagamentos => {
                        this.formasPagamentos = formasPagamentos;

                        if (this.formaPagamento) {
                            const indexFormaPagamento = this.formasPagamentos?.findIndex(formaPagamentoFilter => formaPagamentoFilter.id === this.formaPagamento.id);
                            if (indexFormaPagamento < 0) {
                                this.formasPagamentos.unshift(this.formaPagamento);
                            }
                        }

                        resolve(this.formasPagamentos);
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao pesquisar as formas de pagamentos', error);
                        reject(error);
                    }
                );
        });
    }

    /** Verifica se a forma de pagamento está inativa */
    isSituacaoInativa(situacao: number): boolean {
        return isFormaPagamentoSituacaoInativa(situacao);
    }

    /** Ao alterar a forma de pagamento */
    onChange(idFormaPagamento: number) {
        this.ngModel = idFormaPagamento;
        this.propagateChange(this.ngModel);

        this.formaPagamento = this.formasPagamentos?.find(formaPagamentoFilter => formaPagamentoFilter.id === idFormaPagamento);
        this.formaPagamentoChange.emit(this.formaPagamento);
    }

    /** Seta o focus no select */
    setFocus() {
        jQuery(this.select?.nativeElement).trigger('focus');
    }

    writeValue(value: number) {}

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
}
